import { createContext, useContext } from 'react';

const ClientDetailContext = createContext(null);

export const ClientDetailProvider = ClientDetailContext.Provider;

export const useClientDetail = () => {
  const detail = useContext(ClientDetailContext);
  if (!detail) {
    throw new Error(
      'Client detail tabs must be rendered inside the client detail page.',
    );
  }
  return detail;
};
